import {
  Box,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogTitle,
  Typography,
} from "@material-ui/core"
import { importBoards } from "actions/boards"
import { superBoardImport } from "actions/Clerk/entities"
import axios from "axios"
import ButtonRounded from "components/Common/ButtonRounded"
import ConditionalDialogWrapper from "components/Common/ConditionalDialogWrapper"
import AppContext from "contexts/App"
import { useCallback, useContext, useState } from "react"
import { useDropzone } from "react-dropzone"
import { useMutation } from "react-query"
import api from "store/api"

import Submitted from "./components/Submitted"
import Upload from "./components/Upload"
import useStyles from "./styles"

const UploadCsv = () => {
  const { dialogs, closeDialog, authUser, openSnackBar, token } =
    useContext(AppContext)
  const classes = useStyles()
  const importBoardsMutation = useMutation(importBoards)
  const superBoardImportMutation = useMutation(superBoardImport)

  const thisDialog = dialogs?.["uploadCsv"] || {}
  const { open = false, data = {} } = thisDialog
  const [file, setFile] = useState(null)
  const [loading, setLoading] = useState(false)

  const [step, setStep] = useState(0)

  //if opened from Entity page as a super, passed true to render different piecs of Step 1 & Step 2
  const fromSuper = data?.fromSuper || false
  const entityId = data?.entityId

  const onDrop = useCallback((acceptedFiles) => {
    setFile(acceptedFiles[0])
  }, [])

  let { getRootProps, getInputProps, acceptedFiles, rejectedFiles } =
    useDropzone({
      onDrop,
      accept:
        ".csv,	application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,	application/vnd.ms-excel.sheet.binary.macroEnabled.12,application/vnd.ms-excel,application/vnd.ms-excel.sheet.macroEnabled.12",
    })

  const removeAcceptedFiles = (file) => {
    acceptedFiles.splice(file, 1)
  }
  const handleClose = () => {
    closeDialog("uploadCsv")
    setTimeout(() => {
      setFile(null)
      removeAcceptedFiles()
      setStep(0)
    }, 500)
  }

  const importFunc = async () => {
    if (file) {
      setLoading(true)
      // Request presignedURL - pass file_name and file_type
      const presignedUrlRequest = await api.get("admin/boards/presigned", {
        params: {
          file_name:
            file?.name.substring(0, file?.name.lastIndexOf(".")) || file?.name,
          file_type: file.type,
        },
      })
      const { fields, url } = presignedUrlRequest.data.data

      // Build formData with values returned from AWS presignedURL
      const formData = new FormData()
      Object.entries(fields).forEach(([name, value]) => {
        formData.append(name, value)
      })

      // Append file to form data
      formData.append("file", file)

      try {
        const uploadResponse = await axios({
          method: "post",
          url,
          headers: { "Content-Type": "multipart/form-data" },
          data: formData,
        })
        let data = {
          entityId: fromSuper ? entityId : authUser?.entity_id,
          file_id: fields.key,
          admin_id: authUser?.id,
        }
        if (fromSuper) {
          // super sending csv to be imported
          let superData = { entityId: entityId, file_id: fields.key }
          let superUploadCsv = await superBoardImportMutation.mutateAsync(
            superData
          )
        } else {
          // submit file to files list in entity for matchboard super review
          let mutateData = await importBoardsMutation.mutateAsync(data)
        }
        openSnackBar({
          message: "CSV uploaded",
        })
        setStep(1)
        setLoading(false)
      } catch (error) {
        console.log("ERROR:", error)
        openSnackBar({ message: `Upload failed.` })
        setLoading(false)
      }
    }
  }

  const steps = [
    <Upload
      key={1}
      file={file}
      setFile={setFile}
      loading={loading}
      setLoading={setLoading}
      getRootProps={getRootProps}
      acceptedFiles={acceptedFiles}
      getInputProps={getInputProps}
      fromSuper={fromSuper}
    />,
    <Submitted key={2} fromSuper={fromSuper} />,
  ]

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      classes={{ paper: classes.paper }}
    >
      <DialogTitle disableTypography>
        <Typography variant="h2">Data Import</Typography>
      </DialogTitle>
      {steps[step]}
      <DialogActions>
        <Box
          display="flex"
          justifyContent={step === 0 ? "space-between" : "flex-end"}
          width="100%"
          className={classes.buttonsContainer}
        >
          <ButtonRounded onClick={handleClose}>
            {step === 0 ? "Cancel" : "Close"}
          </ButtonRounded>
          {step === 0 ? (
            <ButtonRounded
              variant="contained"
              color="primary"
              onClick={importFunc}
              disabled={loading}
              className={classes.importButton}
            >
              {loading ? (
                <Box width="50px">
                  <CircularProgress size={15} style={{ color: "#fff" }} />
                </Box>
              ) : (
                "Import"
              )}
            </ButtonRounded>
          ) : null}
        </Box>
      </DialogActions>
    </Dialog>
  )
}

export default UploadCsv
